module.exports = "/assets/34fc5f2ef7488721b290bcfda4ed61f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4B.png
// module id = 1029
// module chunks = 0